/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import dodecahedronUrl from '../../../assets/gems/dodecahedron.svg?inline';
export function Dodecahedron({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: dodecahedronUrl,
        alt: "DodecahedronImage"
    });
}
